<template>
  <div class="wrap-dashboard">
    <headView :option="title" :subtitleOpt="subtitleOpt">
      <headButton :option="buttonOptions"></headButton>
    </headView>
    <div class="panel-dashboard">
      <div class="wrapper-select">
        <section class="panel-dashboard__select-control" v-if="getReport.building">
          <!-- <h4 class="title-section">{{getBuildById($route.params.id).name}}</h4> -->
          <h4 class="title-section">{{ getReport.building.name }}</h4>
          <div class="select-group select-group--report">
            <div class="select-group__item-info">
              <div class="content-description">
                <!-- <span>{{getCPById($route.params.fk).name}}</span> -->
                <span>{{ getReport.checkpoint.name }}</span>
              </div>
              <div class="content-checkpoint">
                <!-- <span>{{getTaskById($route.params.ts).name}}</span> -->
                <span>{{ getReport.task.name }}</span>
              </div>
            </div>
            <!-- <date-picker v-model="dateSelect" class="data-picker-custom" range lang="es" format="DD MMM YYYY" confirm @confirm="changeDate" placeholder="Todas la fechas"></date-picker> -->
            <!-- <air-date-picker></air-date-picker> -->
            <template>
              <div>
                <div class="datepicker-trigger">
                  <input class="input-date" type="text" id="datepicker-trigger" placeholder="Select dates"
                    :value="formatDates(dateOne, dateTwo)">

                  <AirbnbStyleDatepicker :trigger-element-id="'datepicker-trigger'" :mode="'range'"
                    :fullscreen-mobile="true" :date-one="dateOne" :date-two="dateTwo"
                    @date-one-selected="val => { dateOne = val }" @date-two-selected="val => { dateTwo = val }"
                    @apply="changeDate" />
                </div>
              </div>
            </template>
          </div>
          <!-- <div><p>{{dateSelect}}</p></div> -->
        </section>
        <section class="panel-dashboard__view-state" v-if="getReport.historic">
          <div class="content-slideShow content-slideShow--chart">
            <!-- <chartjs-line :labels="labelsComp" :dataset="datasetComp" :option="optionComp"></chartjs-line> -->
            <!-- <canvas id="myChart" width="100%"></canvas> -->
            <div id="myChart" ref="apexChart"></div>
          </div>
        </section>
      </div>
    </div>
    <div class="panel-dashboard-footer">
      <div class="wrapper-select wrapper-select--footer">
        <h4 class="title-section title-section--footer">Historial</h4>
        <div class="table-section">
          <b-table class="table-history" :data="dataTable ? dataTable : []" :striped="isStriped" :narrowed="isNarrowed"
            :loading="isLoading">
            <template slot-scope="props">
              <b-table-column field="id" label="fecha" width="180">
                {{ props.row.fecha }}
              </b-table-column>

              <b-table-column field="hora" label="hora">
                {{ props.row.hora }}
              </b-table-column>

              <b-table-column field="usuario" label="usuario">
                {{ props.row.user }}
              </b-table-column>

              <b-table-column field="answer" :label="unidad"
                :style="[{ fontWeight: 'bold' }, { color: `${(props.row.status == 'well' || props.row.status == 'range') ? `#2ecc71` : (props.row.status == 'bad' || props.row.status == 'outrange') ? `#ff5a5f` : `#f5a623`}` }]">
                {{ props.row.answer }}
              </b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-large">
                    </b-icon>
                  </p>
                  <p>No hay datos en el rango de fechas seleccionadas.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headView from "../Componentes/headView";
import headButton from "../Componentes/headButton";
import { mapGetters } from "vuex";
import { service } from "@/helper/Rest";
import dataChart from "@/helper/range-chart-data.js";
import dataBarChart from "@/helper/bar-chart-data.js";
import ApexCharts from "apexcharts";
import format from 'date-fns/format'
export default {
  name: "dashboard",
  components: {
    headView,
    headButton
  },
  data() {
    return {
      dataTable: [],
      unidad: "",
      isEmpty: true,
      isStriped: true,
      isNarrowed: true,
      isLoading: false,
      title: {
        headText: "Dashboard",
        subtitle: ""
      },
      subtitleOpt: false,
      buttonOptions: {
        btnAction: true,
        valueBtn: "Descargar en Excel",
        ruta: "",
        btnType: "download"
      },
      labels: [],
      dateSelect: "",
      sDate: new Date(),
      eDate: new Date(),
      dataset: [],
      optionR: {},
      cont: 0,
      dataChart,
      dataBarChart,
      myChart: {},
      dateFormat: 'D MMM',
      dateOne: '',
      dateTwo: ''
    };
  },
  async beforeCreate() {
    var id_business = this.$localStorage.get("companyId");
    if (id_business) {
      var users = (await service.getUsers(id_business, this.$store.state.namespace)).data;
      this.$store.commit("addUsers", users);
    }
  },
  watch: {
    getReport: function (n) {
      if (!n) return;

      this.getUnidad();
      if (n.task.labeltype === "well-bad") {
        this.dataBarChart.title.text = `${this.getReport.checkpoint.name} - ${this.getReport.task.name
          }`;
        this.dataBarChart.series[0].name = this.getReport.task.name;
        this.dataBarChart.yaxis.labels.formatter = value => {
          return (
            Number(value).toFixed(1)
          );
        };
        this.dataBarChart.series[0].data = this.getReport.historic.map(
          item => item.value
        );
        this.dataBarChart.labels = this.getReport.historic
          .map(item => {
            let d = new Date(item.date);
            return d;
          })
          .sort(function (a, b) {
            return a - b;
          })
          .map(item => item.toLocaleString());
      } else {
        this.dataChart.annotations.yaxis[0].y = this.getReport.maxRange || 1;
        this.dataChart.annotations.yaxis[0].label.text = "Máximo";
        this.dataChart.annotations.yaxis[1].y = this.getReport.minRange || -1;
        this.dataChart.annotations.yaxis[1].label.text = "Mínimo";
        this.dataChart.annotations.yaxis[0].label.borderColor = "#f44336";
        this.dataChart.annotations.yaxis[1].label.borderColor = "#f44336";
        this.dataChart.title.text = `${this.getReport.checkpoint.name} - ${this.getReport.task.name
          }`;
        this.dataChart.yaxis.labels.formatter = value => {
          return (
            Number(value).toFixed(0) +
            (this.unidad === "numero" || this.unidad === "tarea"
              ? ""
              : this.unidad)
          );
        };

        this.dataChart.series[0].data = this.getReport.historic.map(
          item => {
            if (item.value == undefined) item.value = null
            return item.value
          }
        );
        if (this.dataChart.series[0].data.length === 1) {
          this.dataChart.series[0].data.push(null)
        }
        this.dataChart.yaxis.min =
          Math.min(
            Math.min(...this.dataChart.series[0].data.map(i => {
              if (i == undefined) i = null
              return i
            })),
            this.getReport.minRange
          ) - 5;

        this.dataChart.yaxis.max =
          Math.max(
            Math.max(...this.dataChart.series[0].data.map(i => {
              if (i == undefined) i = null
              return i
            })),
            this.getReport.maxRange
          ) + 5;
        this.dataChart.series[0].name = this.getReport.task.name;
        this.dataChart.labels = this.getReport.historic
          .map(item => {
            let d = new Date(item.date);
            return d;
          })
          .sort(function (a, b) {
            return a - b;
          })
          .map(item => item.toLocaleString());
        if (this.dataChart.labels.length === 1) {
          this.dataChart.labels.push('')
        }
      }

      this.$nextTick(() => {
        if (n.task.labeltype === "well-bad") {
          this.createChart(Object.assign({}, this.dataBarChart));
        } else {
          this.createChart(Object.assign({}, this.dataChart));
        }
        this.getUnidad();
        this.createDataTable(
          this.getReport.historic,
          this.getReport.task.labeltype
        );
      });
    }
  },
  beforeDestroy() {
    this.$store.commit("resetTasks");
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["getUserById", "getReport", "taskById"])
  },
  created() {
    this.sDate.setHours(0, 0, 0);
    this.sDate.setMonth(this.sDate.getMonth() - 1);
    var obj = {
      building: this.$route.params.id,
      checkpoint: this.$route.params.fk,
      task: this.$route.params.ts,
      startDate: this.sDate.toISOString(),
      endDate: this.eDate.toISOString()
    };
    this.$store.dispatch("POSTREPORT", {
      id_business: this.$store.getters.company_id,
      obj: obj
    });
  },
  methods: {
    createChart(chartData) {
      // const ctx = document.getElementById(chartId);
      this.myChart = new ApexCharts(this.$refs.apexChart, chartData);
      this.myChart.render();
    },
    createDataTable: function (arr, type) {
      this.dataTable = arr.filter(i => i.status != 'pending')
        .map(item => {
          var dateObj = new Date(item.date);
          let date = dateObj.toLocaleDateString();
          let time = dateObj.toLocaleTimeString();
          let userEl = item._huser;
          let answerEL = item.answer;

          let obj = {
            fecha: date,
            hora: time,
            user: userEl ? `${userEl.firstName} ${userEl.lastName}` : '',
            answer:
              item.status === 'pending' ? 'pending' : (type == "well-bad" ? (answerEL === "" || answerEL === "BIEN" ? "Bien" : `Mal - ${answerEL}`) : answerEL),
            sortDate: dateObj.getTime(),
            status: item.status
          };
          return obj;
        })
        .sort(function (a, b) {
          return b.sortDate - a.sortDate;
        });
    },
    changeDate() {
      var obj = {
        building: this.$route.params.id,
        checkpoint: this.$route.params.fk,
        task: this.$route.params.ts,
        startDate: new Date(new Date(this.dateOne.replace("-", ".")).setHours(0, 0, 0, 0)).toISOString(),
        endDate: new Date(new Date(this.dateTwo.replace("-", ".")).setHours(23, 0, 0, 0)).toISOString()
      };
      this.$store.dispatch("POSTREPORT", {
        id_business: this.$store.getters.company_id,
        obj: obj
      });
    },
    getUnidad: function () {
      if (this.getReport.task)
        switch (this.getReport.task.labeltype) {
          case "well-bad":
            this.unidad = "tarea";
            break;
          case "pressure":
            this.unidad = "PSI";
            break;
          case "number":
            this.unidad = "numero";
            break;
          case "time":
            this.unidad = " HORAS";
            break;
          case "farenheit":
            this.unidad = "F";
            break;
          case "celcius":
            this.unidad = "C";
            break;
          case "voltage":
            this.unidad = "V";
            break;
          case "percentage":
            this.unidad = "%";
            break;
        }
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat)
      }
      if (dateTwo) {
        formattedDates += ' - ' + format(dateTwo, this.dateFormat)
      }
      return formattedDates
    }
  }
};
</script>
<style lang="scss">
.asd__day {
  padding: 0.3em !important;
}
</style>

<style lang="scss" scoped>
@import "../../assets/styles/1.settings/index";

.panel-dashboard {
  padding-top: 70px;
  max-width: 1000px;

  // width: 100%;
  &__view-state {
    margin: 15px 0;
    display: flex;
    justify-content: space-between;
  }

  &__content-checkPoint {
    display: flex;
    width: 100%;
    // flex-flow: wrap;
    flex-flow: row wrap;
  }
}

.wrapper-select {
  padding: 0 30px;
  width: 100%;

  &--footer {
    max-width: 1000px;
  }
}

.panel-dashboard-footer {
  background-color: #fafafa;
  z-index: 10;
}

.select-group {
  max-width: 1000px;
  display: flex;
  justify-content: space-between;

  &__item-info {
    text-align: left;
  }

  &__item {
    width: 20%;
    // margin-right: 15px;
    // &:last-child {
    //   margin-right: 1px;
    // }
  }

  padding-bottom: 5px;
  border-bottom: 1px solid #dbdbdb;

  &--report {
    padding-bottom: 30px;
  }
}

.title-section {
  font-size: 25px;
  font-weight: bold;
  text-align: left;
  padding: 10px 0;

  &--footer {
    font-size: 23px;
  }
}

.content-slideShow {
  padding: 10px 20px;
  border-radius: 4px;
  border: 2px solid #dbdbdb;

  &--progress {
    width: 100%;
  }

  &--chart {
    border: none;
    width: 100%;
  }
}

.falta_repo_porcentaje {
  color: $colorReportNeutral;
  font-size: 45px;
  font-weight: bold;
  text-align: left;
  padding: 5px 0;
}

.table-section {
  padding-bottom: 30px;
}

.input-date {
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
  border: thin solid #00a699;
}
</style>




// WEBPACK FOOTER //
// src/components/Main/edificioDetalle.vue